(function () {
    'use strict'
    app.controller('updateCCController', ['$scope', '$location', '$cookies', 'UpgradeService', function ($scope, $location, $cookies, upgradeService) {
        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || $cookies.get('_updatecc') == undefined) {
            $cookies.remove('_updatecc', { path: '/' });
            $location.path('/login');
            return;
        }

        var jsonpaymentData = $cookies.get('_updatecc');
        $cookies.remove('_updatecc', { path: '/' });
        if (jsonpaymentData != "") {
            var name = getLocalValue("fullName").split(' ');
            $scope.paymentResponse = {
                req_card_number: jsonpaymentData,
                firstName: name[0]
            }
            $scope.isSuccess = true;

            upgradeService.sendUpdateCCNotification($scope.paymentResponse.req_card_number, $scope.paymentResponse.firstName);
        }
    }]);
})();